import PropTypes from 'prop-types';

import SvgImg from '../../SvgImg';

function ChatIcon(props) {
  const {
    className,
    description,
    src,
    defaultDotDotDot,
    defaultCone,
  } = props;

  return (
    <SvgImg
      className={`chatIcon ${className}`}
      description={description}
      src={src}
      defaultDotDotDot={defaultDotDotDot}
      defaultCone={defaultCone}
    />
  );
}

ChatIcon.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  defaultDotDotDot: PropTypes.bool,
  defaultCone: PropTypes.bool,
};

export default ChatIcon;
